import React from "react";
import Header from "./ui/Header";
import PathFindingAlgorithms from "./pages/PathFindingAlgorithms";

function App() {
  return (
    <>
    
      <PathFindingAlgorithms/>
        {/* <Footer/> */}
    </>
  );
}

export default App;
